export const AUTHOR_CLASSIFICATIONS = [
  { value: 'apoiador_fiel', label: 'Apoiador fiel', color: 'bg-emerald-100 text-emerald-700', icon: 'i-lucide-heart' },
  { value: 'apoiador_ocasional', label: 'Apoiador ocasional', color: 'bg-emerald-50 text-emerald-700', icon: 'i-lucide-thumbs-up' },
  { value: 'em_duvida', label: 'Em dúvida', color: 'bg-amber-100 text-amber-700', icon: 'i-lucide-help-circle' },
  { value: 'neutro', label: 'Neutro', color: 'bg-slate-100 text-slate-600', icon: 'i-lucide-circle' },
  { value: 'critico', label: 'Crítico', color: 'bg-rose-100 text-rose-700', icon: 'i-lucide-frown' },
  { value: 'opositor', label: 'Opositor', color: 'bg-rose-200 text-rose-800', icon: 'i-lucide-shield-alert' },
  { value: 'troll', label: 'Troll', color: 'bg-slate-200 text-slate-800', icon: 'i-lucide-skull' },
  { value: 'influenciador', label: 'Influenciador', color: 'bg-purple-100 text-purple-700', icon: 'i-lucide-zap' },
  { value: 'imprensa', label: 'Imprensa', color: 'bg-blue-100 text-blue-700', icon: 'i-lucide-newspaper' },
  { value: 'lideranca_comunitaria', label: 'Liderança comunitária', color: 'bg-teal-100 text-teal-700', icon: 'i-lucide-users' },
  { value: 'desconhecido', label: 'Desconhecido', color: 'bg-n-slate-3 text-n-slate-11', icon: 'i-lucide-help-circle' },
];

export const classificationLabel = value =>
  AUTHOR_CLASSIFICATIONS.find(c => c.value === value)?.label || value || '';

export const classificationColor = value =>
  AUTHOR_CLASSIFICATIONS.find(c => c.value === value)?.color || 'bg-n-slate-3 text-n-slate-11';

export const classificationIcon = value =>
  AUTHOR_CLASSIFICATIONS.find(c => c.value === value)?.icon || 'i-lucide-circle';
